import React from "react";
import { Toaster } from "react-hot-toast";
import { CampaignTypeFormData } from "../types/campaignType.types";
import { useEditCampaignTypeModal } from "../hooks/useEditCampaignTypeModal";

interface EditCampaignTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CampaignTypeFormData) => void;
  campaignTypeId: number | null;
}

const EditCampaignTypeModal: React.FC<EditCampaignTypeModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  campaignTypeId,
}) => {
  const { formData, errors, isLoading, handleChange, handleClearAll, handleSubmit } =
    useEditCampaignTypeModal({ isOpen, onClose, onSubmit, campaignTypeId });

  const requiredField = <span className="text-danger ms-1">*</span>;

  return (
    <>
      <Toaster position="top-center" />
      <div
        className={`modal-backdrop-custom ${isOpen ? "open" : "closed"}`}
        onClick={onClose}
      ></div>
      <div className={`modal-custom ${isOpen ? "open" : "closed"}`}>
        <div className="modal-content CampaignTypeFormContent">
          <div className="modal-header-custom">
            <h5 className="modal-title-custom">Edit Campaign Type</h5>
            <button className="btn-close-custom" onClick={onClose}>
              <span className="icon-close"></span>
            </button>
          </div>
          <div className="modal-body-custom">
            {isLoading ? (
              <div className="text-center">Loading campaign type...</div>
            ) : (
              <div className="modal-body-content">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-12 col-lg-12 mb-3 input-group-custom">
                      <label className="form-label" htmlFor="name">
                        Campaign Type Name{requiredField}
                      </label>
                      <div className="input-with-icon">
                        <span className="input-icon icon-campaign"></span>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter Campaign Type Name"
                          maxLength={100}
                          className={`form-control-custom ${errors.name ? "is-invalid" : ""}`}
                          disabled={isLoading}
                        />
                        {errors.name && (
                          <div className="invalid-feedback text-danger">
                            {errors.name}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-lg-12 mb-3 input-group-custom">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name="isactive"
                          id="isactive"
                          checked={formData.isactive}
                          onChange={handleChange}
                          className="form-check-input"
                          disabled={isLoading}
                        />
                        <label className="form-check-label" htmlFor="isactive">
                          Active
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            )}
            <div className="modal-footer-custom">
              <button
                className="btn-custom btn-cancel"
                onClick={handleClearAll}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                className="btn-custom btn-primary-custom"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCampaignTypeModal;
